export default __webpack_public_path__ + "static/media/cny-lucky-draw.ab745464.webp";